export default function () {
  const widgetName = 'mainSlideshowConcept1';
  const widgetOpts = mainSlideshowConcept1Opts;
  const $widget = $(`#${widgetName}`);
  let swiperImages;
  let swiperContent;

  const slideDelay = 8000;
  const firstSlideMainHeading = false; // enable this if you need to set the first title as H1 instead of H2

  const swiperContainers = `
    <div class="swiper-container swiper-container-images">
      <div class="swiper-wrapper"></div>
      <div class="arrows-container">
        <div class="swiper-pagination"></div>
      </div>
    </div>

    <div class="content-wrap">
      <div class="content-wrap-inner">
        <h1 class="slide-slogan">Fountain Hills</h1>
        <div class="swiper-container swiper-container-content">
          <div class="swiper-wrapper"></div>
        </div>
      </div>
    </div>  
  `;

  // Slide Template - Images
  function buildSlideTemplateImages(slide) {
    const template = `
      <div class="swiper-slide">
        <div class="swiper-image-container swiper-lazy" data-background="${slide.ImageWithPath}" aria-label="${slide.ImageAlternateText}">
          <div class="swiper-lazy-preloader"></div>
        </div>
      </div>
    `;

    return template;
  }

  // Slide Template - Content
  function buildSlideTemplateContent(slide, _isFirstSlide) {
    let title;
    if (firstSlideMainHeading) {
      title = _isFirstSlide
        ? `<h1 class="slide-title">${slide.Description}</h1>`
        : `<h2 class="slide-title">${slide.Description}</h2>`;
    } else {
      title = `<p class="slide-title">${slide.Title}</p>`;
    }

    const template = `
      <div class="swiper-slide">
        <div class="swiper-content-container">
          <div class="wrap-content-slide">
          ${title}
          </div>
        </div>
      </div>
    `;

    return template;
  }

  // Swiper Initialization
  function initSwiper(widgetData) {
    if (widgetData.length <= 1) {
      $(`#${widgetName} .content-wrap .swiper-wrapper`).addClass('single-slide');
    }
    const swiperWidgetImagesWrapper = $(`#${widgetName} .swiper-container-images .swiper-wrapper`);
    const swiperWidgetContentWrapper = $(
      `#${widgetName} .swiper-container-content .swiper-wrapper`,
    );

    for (const [index, slide] of widgetData.entries()) {
      const isFirstSlide = index === 0;
      swiperWidgetImagesWrapper.append(buildSlideTemplateImages(slide));
      swiperWidgetContentWrapper.append(buildSlideTemplateContent(slide, isFirstSlide));
    }

    const swiperWidgetImages = new Swiper(`#${widgetName} .swiper-container-images`, {
      speed: 600,
      autoplay: {
        delay: slideDelay,
        disableOnInteraction: false,
      },
      loop: widgetData.length > 1,
      watchOverflow: true,
      spaceBetween: 0,
      centeredSlides: false,
      preloadImages: false,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1,
      },
      a11y: true,
      autoHeight: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
    });

    const swiperWidgetContent = new Swiper(`#${widgetName} .swiper-container-content`, {
      speed: 600,
      spaceBetween: 0,
      centeredSlides: false,
      loop: widgetData.length > 1,
      watchOverflow: true,
      a11y: true,
      autoHeight: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        nextEl: `#${widgetName} .swiper-button-next`,
        prevEl: `#${widgetName} .swiper-button-prev`,
      },
      pagination: {
        el: `#${widgetName} .swiper-pagination`,
        clickable: true,
      },
    });
    swiperWidgetImages.controller.control = swiperWidgetContent;
    swiperWidgetContent.controller.control = swiperWidgetImages;

    swiperImages = swiperWidgetImages;
    swiperContent = swiperWidgetContent;

    // Observer to stop autoplay when user is not looking at the slider
    const sliderToObserve = $(`#${widgetName} .swiper-container-images`).get(0);
    if (sliderToObserve) {
      const observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              swiperWidgetImages.autoplay.start();
            } else {
              swiperWidgetImages.autoplay.stop();
            }
          }
        },
        { threshold: 0.3 },
      );

      observer.observe(sliderToObserve);
    }
  }
  // Fetch data and initialize widget
  saffire.utils.getWidgetData(widgetOpts).then(function (response) {
    if (response.Slides.length > 0) {
      $widget.html(swiperContainers);
      initSwiper(response.Slides);
      updateSwiper(swiperImages, swiperContent);
    } else {
      console.log(response);
      console.log('Error: No Data for swiperWidget');
    }
  });
}

function updateSwiper(swiperImages, swiperContent) {
  swiperImages.update();
  swiperContent.update();
}
